import { render, staticRenderFns } from "./CheckOneOption.vue?vue&type=template&id=274fdcd6&scoped=true&"
import script from "./CheckOneOption.vue?vue&type=script&lang=js&"
export * from "./CheckOneOption.vue?vue&type=script&lang=js&"
import style0 from "./CheckOneOption.vue?vue&type=style&index=0&id=274fdcd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fdcd6",
  null
  
)

export default component.exports